import * as z from 'zod';

export const signature = z.object({ email: z.string().email(), password: z.string().min(1, 'Password too short') });
